import { useLocation } from "@/lib/router-compat";

export type SiteLang = "en" | "es" | "zh-cn";

export const useLanguage = (): SiteLang => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/zh-cn")) return "zh-cn";
  if (pathname.startsWith("/es")) return "es";
  return "en";
};

/** Get the lang prefix for links */
export const langPrefix = (lang: SiteLang) => {
  if (lang === "zh-cn") return "/zh-cn";
  if (lang === "es") return "/es";
  return "/en";
};
